import React from 'react'

export const useUnmountEffect = (fn, deps = []) => {
  return React.useEffect(() => () => fn(), deps)
}
